module.exports = __webpack_public_path__ + "img/location.1e54d235.svg";